<template>
  <div>
    <div class="drop" styles="max-width:523px" @dragover.prevent @drop="onDrop" onmouseover="">
      <label v-if="!preview" class="display-inline">
          <i class="icon ico-upload update_icon"></i>
          <div class="drag_description">
            Archivos jpg y png, de un tamaño de 600px por 900px (600 de ancho y 900 de alto) a una resolución no menor de 72 dpi y un peso máximo de 2mb.
          </div>
          <input type="file" name="image" @change="onChange" v-validate="'required|image'" data-vv-as="Imagen">
      </label>
        <div class="hidden display-inline picked image" v-else>
          <i class="icon ico-image update_icon"></i>
          <!-- <img src="@/assets/icons/image-upload.svg" alt="Image upload" class="update_icon"> -->
          <p class="drag_description">{{file.name}}</p>
          <button class="btn btn-delete-upload-img" @click="removeFile">
            <img src="@/assets/icons/close-white.svg" alt="Close icon">
          </button>
        </div>
    </div>
    <!-- <span class="input-error">{{ errors.first('image')  }}</span> -->
    <span class="input-error">{{ fileErrors  }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  inject: ['$validator'],
  name: 'DragAndDrop',
  data: function(){
    return {
      preview: '',
      file: {},
      fileErrors: ''
    }
  },
  mounted: function(){
    if (this.$route.name == 'new_offer'){
      this.preview = this.getDummyOffer.preview,
      this.file = this.getDummyOffer.images
    } else {
      this.preview = this.getDummyOffer.images
      this.file.name = this.getDummyOffer.images.split('/media/offer_imgs/')[1]
    }
  },
  methods: {
    onDrop: function(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.createFile(files[0]);
    },
    onChange(e) {
      var files = e.target.files;
      this.createFile(files[0]);
    },
    createFile(file) {
      if (!file.type.match('image.*') || file.size > 2048000) {
        this.fileErrors = `La imagen no cumple con los requerimientos indicados.`
        return;
      }
      this.fileErrors = ''
      var reader = new FileReader();
      var vm = this;
      // Pasamos valor
      reader.onload = function(e) {
        vm.preview = e.target.result;
        vm.setOfferPreview(vm.preview);
      }
      this.file = file
      reader.readAsDataURL(file);
      this.setOfferImage(file)
    },
    removeFile() {
      this.preview = null;
      this.setOfferPreview(this.preview)
      this.setOfferImage(this.preview)
    },
    ...mapActions('offers', [
      'setOfferPreview',
      'setOfferImage'
    ])
  },
  computed: {
    ...mapGetters('offers', [
      'getDummyOffer'
    ])
  }
}
</script>

<style lang="sass">
input[type="file"]
  position: absolute
  top: 0
  left: 0
  opacity: 0
  z-index: -1
.helper
  height: 100%
  display: inline-block
  vertical-align: middle
  width: 0
.display-inline
  cursor: pointer
  display: inline-block
  width: 100%
  position: relative
  border: 1px dashed #aab9bd
  border-radius: 2px
.drop
  width: 100%
.picked
  border: 1px solid $secondary
  .icon
    color: $secondary
.img-description
  width: 229px
  height: 36px
  font-size: 12px
  font-weight: 300
  color: #636363
  display: inline-block
  text-align: left
.drop button
  display: block
.drag_description
  width: calc(100% - 126px)
  display: inline-block
  word-break: break-word
  font-family: Muli
  font-size: 12px
  font-weight: 300
  color: #302f2f
  margin: 24px 24px 24px 72px
  @include tablet-portrait
    width: calc(100% - 80px)
.update_icon
  font-size: 28px
  color: #d0d0d0
  display: inline-block
  position: absolute
  width: 24px
  height: 24px
  top: calc(50%)
  left: 24px
  transform: translateY(-50%)
.drop:hover
  cursor: pointer!important
  .display-inline
    border: 1px dashed $secondary-hover
  i 
    color: $secondary-hover
.input-error
  color: $danger
  font-family: $body-font
  font-weight: 300
  font-size: 12px
</style>


